import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Accessible Q&A accordion used by room and guide pages (the FAQ text is also emitted as FAQPage JSON-LD by the page).
export default function FaqAccordion({ items = [], title, id = 'faq' }) {
  const [open, setOpen] = useState(0);
  if (!items.length) return null;
  return (
    <section aria-labelledby={`${id}-title`} data-testid={`${id}-section`}>
      {title && <h2 id={`${id}-title`} className="font-serif text-2xl md:text-3xl text-slate-900 mb-6">{title}</h2>}
      <div className="space-y-3">
        {items.map((f, i) => (
          <div key={f.q} className={`border rounded-xl overflow-hidden transition-colors ${open === i ? 'border-amber-300 bg-amber-50/40' : 'border-slate-200 hover:border-amber-200'}`} data-testid={`${id}-item-${i}`}>
            <button type="button" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i} className="w-full flex items-center justify-between gap-4 p-5 text-left">
              <span className="text-slate-800 font-medium text-sm md:text-base">{f.q}</span>
              <ChevronDown className={`w-5 h-5 text-amber-600 flex-shrink-0 transition-transform duration-300 ${open === i ? 'rotate-180' : ''}`} />
            </button>
            <div className={`grid transition-[grid-template-rows] duration-300 ${open === i ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
              <p className="overflow-hidden px-5 pb-0 text-slate-600 text-sm leading-relaxed" style={{ paddingBottom: open === i ? '1.25rem' : 0 }}>{f.a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export const faqNodes = (items = []) => items.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } }));
